import * as React from "react";
import { inject, observer } from "mobx-react";
import { MessagesStore } from "../stores";
import { IMessage } from "../../../interfaces/IMessage";
import { IARotator } from "../../rotator/Rotator";
import { IRotatorData } from "../../rotator/Rotator.service";
import { ILike } from "../../../interfaces/ILike";
import DateTimeService from "../../../services/DateTimeService";
import { Helper } from "../../../Helper";

export interface IRotatorProps {
  messagesStore?: MessagesStore;
}

@inject("messagesStore")
@observer
export default class Rotator extends React.Component<IRotatorProps> {
  private dateTimeService: DateTimeService = new DateTimeService();

  constructor(props, state) {
    super(props, state);
  }

  public render(): JSX.Element {
    let data: IRotatorData[];
    if (this.props.messagesStore.messages != undefined && this.props.messagesStore.messages[0]) {
      data = this.props.messagesStore.messages.map((message: IMessage, cardIndex) => {
        const date = message.startDate;
        let content = message.content;
        if (!content) {
          content = "";
        }
        let div = document.createElement("div");
        div.innerHTML = content.replace(/<\/p>/g, "</p> ").replace(/<\/h1>/g, "</h1> ").replace(/<\/h2>/g, "</h2> ").replace(/<\/li>/g, "</li> ");
        const contentText = (this.props.messagesStore.instance?.settings?.enableTeaser || localStorage.getItem("enableTeaser")) && message.teaser ? message.teaser : (div.textContent || div.innerText || "");
        let author = message.author;
        if (message.contacts && message.contacts.length > 0) {
          author = message.contacts[0];
        }
        let imageUrl = message.image;
        if (imageUrl) {
          imageUrl = imageUrl.replace("DefaultRendition", "StandardLarge");
        }

        let timespan: string = undefined;
        if (message.startDate && message.endDate) {
          if (this.props.messagesStore.displayDateOnCover) {
            timespan = this.dateTimeService.getEventString(message.startDate, message.endDate, message.allDayEvent, true);
          } else {
            timespan = this.dateTimeService.getEventStringDateTimeFormat(message.startDate, message.endDate, message.allDayEvent);
          }
        }
        let videoUrl = message.videoUrl;
        if ((location.href.includes("sharepoint.com") && message.videoEmbedCode) || (videoUrl == undefined && message.videoEmbedCode)) {
          videoUrl = Helper.getVideoSrcFromEmbedCode(message.videoEmbedCode);
        }
        return {
          id: message.id.toString(),
          tenant: this.props.messagesStore.tenant,
          component: "Message",
          instance: this.props.messagesStore.instance != undefined ? this.props.messagesStore.instance.instanceName : "Default",
          token: this.props.messagesStore.token,
          environment: this.props.messagesStore.environment,
          source: "SharePoint",
          user: this.props.messagesStore.user,
          author: author,
          likesEnabled: this.props.messagesStore.likesEnabled,
          commentsEnabled: this.props.messagesStore.commentsEnabled,
          modifiedDate: date,
          title: message.title,
          teaser: contentText,
          item: message,
          videoUrl: videoUrl,
          image: imageUrl,
          iaMessageBgImagesFromBlob: message.iaMessageBgImagesFromBlob,
          iaConfiguration: message.iaConfiguration,
          timespand: timespan,
          likes: this.props.messagesStore.messages[cardIndex].likes,
          commentCount: this.props.messagesStore.messages[cardIndex].commentCount,
          itemTitleColor: this.props.messagesStore.textColor,
          itemTextColor: this.props.messagesStore.textColor,
          borderColor: this.props.messagesStore.borderColor,
          borderRadius: this.props.messagesStore.borderRadius,
          categories: message.categories ?? [],
          showCommandBarItems:
            this.props.messagesStore.userRole == "Administrator" ||
            (this.props.messagesStore.userRole == "Editor" && message.author?.userPrincipalName == this.props.messagesStore.user?.userPrincipalName),
          showSkeleton: true,
          showUniqueViews: this.props.messagesStore.showUniqueViews,
          showLikes: this.props.messagesStore.showLikes,
          showComments: this.props.messagesStore.showComments,
          highlightColor: this.props.messagesStore.rollupHighlightColor,
          backgroundColor: this.props.messagesStore.backgroundColor,
          onClickEdit: (messageToEdit: IMessage) => {
            if (this.props.messagesStore.instance && messageToEdit?.iaConfiguration?.composerComponents) {
              this.props.messagesStore.editMessage(messageToEdit);
            } else {
              this.props.messagesStore.showConvertToComposerPopup = messageToEdit;
            }
          },
          onClickDelete: (messageToDelete: IMessage) => (this.props.messagesStore.messageToDelete = messageToDelete),
          onClickOpen: (messageToOpen: IMessage) => this.props.messagesStore.openMessage(messageToOpen),
          likesUpdated: (likes: ILike[]) => {
            this.props.messagesStore.messages[cardIndex].likes = likes;
          },
          commentsUpdated: (comments: number) => {
            this.props.messagesStore.messages[cardIndex].commentCount = comments;
          },
          commentsClick: (message: IMessage) => {
            this.props.messagesStore.commentsClick(message);
          },
          uniqueViewsCount: this.props.messagesStore.messages[cardIndex].uniqueViews,
          isUnread: !message.isRead && this.props.messagesStore.instance?.settings?.enableReadUnreadMessage,
          showPinIcon: message.isPinned && (new Date(message.pinnedEndDate) > new Date())
        };
      });
    }
    const fetchingContent = data === undefined && this.props.messagesStore.isFetchingMessages;
    if (this.props.messagesStore.messages?.length === 0) {
      data = [];
    }
    return (
      <div
        style={{
          width: "100%",
          height: "auto",
        }}
      >
        <IARotator
          component={this.props.messagesStore.component}
          data={data}
          showSkeleton={fetchingContent}
          width={this.props.messagesStore.width}
          showTitle={this.props.messagesStore.showTitle}
          showCategories={this.props.messagesStore.showCategories}
          showTeaser={this.props.messagesStore.showTeaser}
          showAuthor={this.props.messagesStore.showAuthor}
          showStartDate={this.props.messagesStore.showStartDate}
          showLikes={this.props.messagesStore.showLikes}
          showComments={this.props.messagesStore.showComments}
          borderRadius={this.props.messagesStore.borderRadius}
          borderColor={this.props.messagesStore.borderColor}
          showDropShadow={this.props.messagesStore.showDropShadow}
          isMobile={this.props.messagesStore.isMobile}
          showUniqueViews={this.props.messagesStore.showUniqueViews}
          showLocation={this.props.messagesStore.showLocation}
          showTimespand={this.props.messagesStore.showTimespand}
          highlightColor={this.props.messagesStore.rollupHighlightColor}
          hasDarkBackground={this.props.messagesStore.hasDarkBackground}
          showPaging={this.props.messagesStore.showPaging}
          highlightUnread={this.props.messagesStore.instance?.settings?.highlightUnread}
          environment={this.props.messagesStore.environment}
          tenant={this.props.messagesStore.tenant}
          token={this.props.messagesStore.token}
          fontSlots={this.props.messagesStore.fontSlots}
          userLocation={this.props.messagesStore.userLocation}
          autoRotate={this.props.messagesStore.autoRotate}
          autoRotateInterval={this.props.messagesStore.autoRotateInterval}
          displayDateOnCover={this.props.messagesStore.displayDateOnCover}
          showLikesDimmed={this.props.messagesStore.loadingCommentsAndLikes && this.props.messagesStore.showLikes}
          showCommentsDimmed={this.props.messagesStore.loadingCommentsAndLikes && this.props.messagesStore.showComments}
          showUniqueViewsDimmed={this.props.messagesStore.loadingUniqueViews && this.props.messagesStore.showUniqueViews}
          showEmojiPickerExpandButton={this.props.messagesStore.instance?.settings?.showEmojiPickerExpandButton}
          reactionOptions={this.props.messagesStore.instance?.settings?.reactionOptions}
        />
      </div>
    );
  }


}
